import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {FieldWithIcon} from 'shells/field-with-icon/field-with-icon';
// @ts-expect-error - imported from .js/.jsx file
import {CheckmarkIcon} from 'shells/icon/svg/checkmark-icon';
import {WarningIcon} from 'shells/icon/svg/warning-icon';
import {Link} from 'shells/link/link';
import {TextField} from 'shells/textfield/textfield';

import type {SmsEditionFragment_from as Channel} from 'nutshell-graphql-types';

import {useGetSessionUser} from '../../core/use-get-session-user';

type Props = {
    from: Channel | null | undefined;
};
export function SentFromField(props: Props) {
    const phoneNumber = props.from && props.from.phone && props.from.phone.numberFormatted;
    const {user} = useGetSessionUser();
    const shouldShowSettingsLink = Boolean(user && user.permissions.canAccessSetup);

    return phoneNumber ? (
        <FieldWithIcon icon={CheckmarkIcon} iconColor='green'>
            {/* @ts-expect-error */}
            <TextField size='small' value={`Configured: ${phoneNumber}`} disabled={true} />
        </FieldWithIcon>
    ) : (
        <>
            <FieldWithIcon icon={WarningIcon} iconColor={'error'}>
                {/* @ts-expect-error */}
                <TextField size='small' value='SMS has not been configured' disabled={true} />
            </FieldWithIcon>
            <div className='my-16'>
                To send outbound text messages from Nutshell, you must enroll your business and
                configure a phone number.
            </div>
            {shouldShowSettingsLink && (
                // @ts-expect-error
                <Link as={RoutedLink} to='/marketing/sms-setup' variant='primary' size='small'>
                    Get started
                </Link>
            )}
        </>
    );
}
